import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    selectAll: {
        marginBottom: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        borderBottom: `1px solid${theme.colors.gray[200]}`,
    },
    checkbox: {
        padding: 0,
        pointerEvents: 'none',
        marginRight: theme.spacing(1.5),
    },
}));
//# sourceMappingURL=SelectAllOption.styles.js.map